import { IconAnimals, IconBriefcase, IconCell, IconChart, IconClose, IconDroplet, IconHospital, IconLineage, IconSperm } from '../../../common/icons';
import { PRODUCTION_CARDS } from '../../../core/constants/kpis';
import { fmtNum } from '../utils/format';

// view=summary → production{}. Cards de totales (un número grande por etapa).

const ICONS = {
    briefcase: IconBriefcase,
    droplet:   IconDroplet,
    sperm:     IconSperm,
    cell:      IconCell,
    lineage:   IconLineage,
    animal:    IconAnimals,
    hospital:  IconHospital,
    close:     IconClose,
};

export default function ProductionCards({ production }) {
    const data = production || {};
    return (
        <div className="report-totals">
            {PRODUCTION_CARDS.map((card) => {
                const Icon = ICONS[card.icon] || IconChart;
                return (
                    <article key={card.key} className="report-total-card" data-accent={card.accent}>
                        <span className="report-total-card__icon"><Icon /></span>
                        <span className="report-total-card__body">
                            <span className="report-total-card__value">{fmtNum(data[card.key])}</span>
                            <span className="report-total-card__label">{card.label}</span>
                        </span>
                        <span className="report-total-card__bar" />
                    </article>
                );
            })}
        </div>
    );
}
